<template>
  <div>
    <!-- ARTISTS -->
    <div class="uk-child-width-1-2@s uk-child-width-1-3@m uk-text-center uk-grid-medium" uk-grid>
      <template v-for="u in instagram">
        <a :key="u.id" :href="'#' + u.id" uk-toggle>
          <img :src="u.profilePic" />
          <p>{{ u.fullName }}</p>
        </a>
      </template>
    </div>

    <!-- MODAL -->
    <div v-for="u in instagram" :key="u.id" :id="u.id" class="uk-modal-full" uk-modal>
      <div class="uk-modal-dialog">
        <button
          class="uk-modal-close-full uk-close-large"
          type="button"
          uk-close
        />
        <div class="uk-grid-collapse uk-child-width-1-2@s uk-flex-middle" uk-grid>
          <div
            class="uk-background-cover"
            :style="'background-image: url(' + u.profilePic + ');'"
            uk-height-viewport
          />
          <div class="uk-padding-large">
            <h1>
              {{ u.fullName }}
            </h1>
            <h4>{{ u.title }}</h4>
            <div class="uk-flex uk-flex-between" uk-flex>
              <h5 class="uk-text-meta uk-margin-remove">
                {{ u.color }}
              </h5>
              <h5 class="uk-text-meta uk-margin-remove">
                {{ u.type }}
              </h5>
            </div>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Nemo sint consequuntur labore eveniet adipisci, est voluptat.</p>
            <div class="uk-child-width-1-2@s uk-child-width-1-4@m uk-text-center uk-grid-medium" uk-lightbox="animation: slide" uk-grid>
              <div v-for="i in u.images" :key="i.node.id">
                <a :href="i.node.display_url" class="uk-inline-clip uk-transition-toggle" tabindex="0">
                  <img :src="i.node.thumbnail_src" class="uk-transition-scale-up uk-transition-opaque" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "allArtists",
  data() {
    return {
      limit: 3,
      instagram: [{
        id: "studio8_beratibishi",
        insta: "studio8_beratibishi",
        fullName: "Berat Ibishi",
        profilePic: null,
        title: "VD",
        color: "Svart/Vit",
        type: "Realistiskt",
        images: null,
      },
      {
        id: "granitibishi_studio8",
        insta: "granitibishi_studio8",
        fullName: "Granit Ibishi",
        profilePic: null,
        title: "",
        color: "Svart/Vit och färger",
        type: "Realistiskt och Cartoon",
        images: null,
      },
      {
        id: "lynnwindletattoo",
        insta: "lynnwindletattoo",
        fullName: "Lynn Windle",
        profilePic: null,
        title: "Lärling",
        color: "Svart/Vit och färger",
        type: "Realistiskt",
        images: null,
      },
      {
        id: "tonton_tattoo",
        insta: "tonton.tattoo",
        fullName: "Antonio",
        profilePic: null,
        title: "Lärling",
        color: "Svart/Vit och färger",
        type: "Realistiskt",
        images: null,
      }
      ],
    }
  },
  mounted() {
    this.instagram.forEach(o => this.loadPic(o.insta));
  },
  methods: {
    loadPic: async function(username) {
      var pic = await this.fetchUsername(username);
      this.instagram.filter(o => o.insta === username).forEach(o => o.profilePic = pic.graphql.user.profile_pic_url_hd);
      this.instagram.filter(o => o.insta === username).forEach(o => o.images = pic.graphql.user.edge_owner_to_timeline_media.edges);
    },
    fetchUsername: async function(username) {
      return await fetch(`https://www.instagram.com/${username}/?__a=1`).then(r => r.json());
    },
  }
};
</script>
